import { render } from "./StartGift.vue?vue&type=template&id=4d213bfa&scoped=true"
import script from "./StartGift.vue?vue&type=script&lang=ts"
export * from "./StartGift.vue?vue&type=script&lang=ts"

import "./StartGift.vue?vue&type=style&index=0&id=4d213bfa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d213bfa"

export default script